<template>
  <LoginPage />
</template>

<script>
  import LoginPage from '../components/LoginPage'

  export default {
    components: {
      LoginPage
    }
  }
</script>
